import React from "react";
import "./Footer.css";
import footerlogo from '../Assets/footer-logo.png'
import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaInstagram } from "react-icons/fa";

import footerbg from '../Assets/footericon.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container-fluid">
        <div className="row no-gutters">
          {/* Left Side */}
          <div className="col-md-4 footer-left d-flex flex-column align-items-center justify-content-center">
            <img src={footerlogo} alt="Nova EduBridge" className="footer-logo" />
            <img className="footer-bg" src={footerbg} alt="" srcset="" />
            <p className="footer-call-text">CALL US TODAY</p>
            <h3 className="footer-phone">+91 99020 43004</h3>
           <div className="footer-social">
             <a href="https://www.instagram.com/novaedubridge/?hl=en" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61583095202515" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/109888916/admin/dashboard/" aria-label="Linked in"><FaLinkedinIn /></a>
            <a href="https://x.com/NovaEdubridge" aria-label="Twitter"><FaXTwitter /></a>
           
           
            
            </div>
          </div>

          {/* Right Side */}
          <div className="col-md-8 footer-right">
            <div className="row">
              <div className="col-md-3">
                <h5>Quick Links</h5>
                <ul className="footer-links">
                  <li><a href="/">Home</a></li>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/services">Services</a></li>
                  <li><a href="/courses">Test Preparation</a></li>
                  <li><a href="/careers">Careers</a></li>
                  <li><a href="/Contact">Contact us</a></li>
                   <li><a href="/privacy-policy">Privacy Policy</a></li>
                  <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                </ul>
              </div>
              <div className="col-md-3">
                <h5>Destinations</h5>
                <ul className="footer-links">
  <li><a href="/destinations/USA">USA</a></li>
  <li><a href="/destinations/UK">UK</a></li>
  <li><a href="/destinations/Australia">Australia</a></li>
  <li><a href="/destinations/Canada">Canada</a></li>
  <li><a href="/destinations/NewZealand">New Zealand</a></li>
  <li><a href="/destinations/Ireland">Ireland</a></li>
  <li><a href="/destinations/Germany">Germany</a></li>
  <li><a href="/destinations/France">France</a></li>
  <li><a href="/destinations/Europe">Europe</a></li>
  <li><a href="/destinations/Dubai">Dubai</a></li>
  <li><a href="/destinations/Singapore">Singapore</a></li>
</ul>

              </div>

              <div className="col-md-3">
                <h5>Destinations</h5>
                <ul className="footer-links">

  <li><a href="/destinations/Switzerland">Switzerland</a></li>
  <li><a href="/destinations/Australia">Australia</a></li>
  <li><a href="/destinations/Afghanistan">Afghanistan</a></li>
  <li><a href="/destinations/Uzbekistan">Uzbekistan</a></li>
  <li><a href="/destinations/Kazakhstan">Kazakhstan</a></li>
  <li><a href="/destinations/Kyrgyzstan">Kyrgyzstan</a></li>
  <li><a href="/destinations/Russia">Russia</a></li>
  <li><a href="/destinations/Georgia">Georgia</a></li>
  <li><a href="/destinations/Poland">Poland</a></li>
  <li><a href="/destinations/Italy">Italy</a></li>
  <li><a href="/destinations/Netherlands">Netherlands</a></li>
    <li><a href="/destinations/China">China</a></li>
      <li><a href="/destinations/South Korea">South Korea</a></li>
  <li><a href="/destinations/Asia">Asia</a></li>
</ul>

              </div>

              <div className="col-md-3">
                <h5>Services</h5>
                <ul className="footer-links">
                  <li><a href="/services/university-country-course-selection">University/Country/Course selection</a></li>
                  <li><a href="/services/career-counselling-and-profile-evaluation"> Career Counselling & Profile Evaluation </a></li>
                  <li><a href="/services/test-preparation">Test Preparation - IELTS / GRE / GMAT / TOEFL/ PTE/ SAT</a></li>
                  <li><a href="/services/application-submission">Application Submission</a></li>
                  <li><a href="/services/visa-counseling">
                  Visa Counseling</a></li>
                  <li><a href="/services/pre-departure-briefing">
                  Pre Departure Briefing</a></li>
                  <li><a href="/services/post-arrival-assistance-and-services">Post Arrival Assistance & Services</a></li>
                  <li><a href="/services/assistance-in-accommodation">
                  Assistance in Accommodation</a></li>
                  <li><a href="/services/education-loan-assistance">
                  Education Loan Assistance</a></li>
                  <li><a href="/services/flight-ticket-booking-forex-and-insurance">Flight Ticket Booking, Forex and Insurance</a></li>
                </ul>
              </div>
            </div>
            <p className="footer-bottom-text">
              © 2025 Nova EduBridge Study Abroad Consultant. All rights reserved.
              Designed & Developed by <span className="footer-highlight"><a href="https://www.digiworq.com" target="_blank">DIGIWORQ</a></span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
